// Shared helpers for the e-Way bill Generate / View dialogs.

// Indian digit grouping with exactly 2 decimals: xx,xx,xxx.00
const INR = new Intl.NumberFormat("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
});

export function formatINR(amount) {
    const n = Number(amount);
    if (amount === null || amount === undefined || isNaN(n)) return "0.00";
    return INR.format(n);
}

// Government transMode codes -> human labels
export const TRANS_MODE_OPTIONS = [
    { value: "1", label: "Road" },
    { value: "2", label: "Rail" },
    { value: "3", label: "Air" },
    { value: "4", label: "Ship" },
];

export function transModeLabel(code) {
    const found = TRANS_MODE_OPTIONS.find((o) => o.value === String(code));
    return found ? found.label : code || "-";
}

/**
 * Defensively parse a portal date string of the form "dd/MM/yyyy hh:mm:ss AM/PM".
 * Falls back to the native Date parser, then returns null if unparseable.
 * @returns {Date|null}
 */
export function parseEwayDate(str) {
    if (!str) return null;
    if (str instanceof Date) return isNaN(str) ? null : str;
    const m = String(str).match(
        /^(\d{1,2})\/(\d{1,2})\/(\d{4})\s+(\d{1,2}):(\d{2}):(\d{2})\s*(AM|PM)?$/i
    );
    if (m) {
        let [, dd, mm, yyyy, hh, min, ss, ap] = m;
        let hour = parseInt(hh, 10);
        if (ap) {
            const upper = ap.toUpperCase();
            if (upper === "PM" && hour < 12) hour += 12;
            if (upper === "AM" && hour === 12) hour = 0;
        }
        const d = new Date(
            parseInt(yyyy, 10),
            parseInt(mm, 10) - 1,
            parseInt(dd, 10),
            hour,
            parseInt(min, 10),
            parseInt(ss, 10)
        );
        return isNaN(d) ? null : d;
    }
    const fallback = new Date(str);
    return isNaN(fallback) ? null : fallback;
}

// Pretty-print a parsed date (or pass through the raw string if unparseable).
export function formatEwayDate(str) {
    const d = parseEwayDate(str);
    if (!d) return str || "-";
    const day = String(d.getDate()).padStart(2, "0");
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const hr = d.getHours();
    const min = String(d.getMinutes()).padStart(2, "0");
    const ampm = hr >= 12 ? "PM" : "AM";
    const hr12 = hr % 12 || 12;
    return `${day} ${months[d.getMonth()]} ${d.getFullYear()}, ${hr12}:${min} ${ampm}`;
}

// Group an e-Way bill number into blocks of 4, e.g. 1421 5173 4844.
export function groupEwbNo(no) {
    if (!no) return "-";
    return String(no).replace(/\s+/g, "").replace(/(.{4})/g, "$1 ").trim();
}

// Document type code -> NIC label.
const DOC_TYPE_LABELS = { INV: "Tax Invoice", BIL: "Bill of Supply", BOE: "Bill of Entry", CHL: "Delivery Challan", OTH: "Others" };
export function docTypeLabel(code) {
    return DOC_TYPE_LABELS[String(code || "").toUpperCase()] || code || "-";
}

// True when a "valid upto" date is in the past.
export function isExpired(validUpto) {
    const d = parseEwayDate(validUpto);
    if (!d) return false;
    return d.getTime() < new Date().getTime();
}
